import React, { memo } from 'react'
import { useMediaQuery } from '@material-ui/core'
import Select from '@material-ui/core/Select'
import NativeSelect from '@material-ui/core/NativeSelect'
import MenuItem from '@material-ui/core/MenuItem'
import { handleChange } from '../app/formSlice'
import { useAppDispatch, useAppSelector } from '../app/hooks/reduxHooks'
import styles from './SelectInput.module.sass'

function SelectInput({ label, menuItems, name }) {
    const value = useAppSelector(state => state.form[name])
    const dispatch = useAppDispatch()
    const isMobile = useMediaQuery('(max-width: 760px)')
    const setValue = e => {
        dispatch(handleChange({
            name: e.target.name,
            value: e.target.value
        }))
    }
    return (
        <div className={styles.root}>
            <p className={styles.label}>{label} *</p>
            {isMobile ? (
                <NativeSelect
                    name={name}
                    fullWidth
                    native={isMobile}
                    MenuProps={{
                        disableScrollLock: true,
                        disableAutoFocusItem: true,
                        disableEnforceFocus: true,
                        disableRestoreFocus: true,
                        disableAutoFocus: true,
                        keepMounted: true,
                        disablePortal: true,
                        MenuListProps: {
                            disablePadding: true
                        }
                    }}
                    onChange={setValue}
                    value={value}
                    classes={{ focused: styles.focused }}
                    defaultValue={menuItems[0]}
                    inputProps={{
                        className: styles.input
                    }}
                    disableUnderline
                    IconComponent={() => (
                        <svg className={styles.icon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 8L12 16L4 8" stroke="#4A4646" strokeWidth="2"/>
                        </svg>
                    )}
                >
                {menuItems.map((e, i) =>
                    <option
                        key={i}
                        value={e.replace(/\s+/g, '')}
                    >
                        {e}
                    </option>)}
                </NativeSelect>
            ) : (
                <Select
                    name={name}
                    fullWidth
                    native={isMobile}
                    MenuProps={{
                        disableScrollLock: true,
                        disableAutoFocusItem: true,
                        disableEnforceFocus: true,
                        disableRestoreFocus: true,
                        disableAutoFocus: true,
                        keepMounted: true,
                        disablePortal: true,
                        MenuListProps: {
                            disablePadding: true
                        }
                    }}
                    onChange={setValue}
                    value={value}
                    classes={{ focused: styles.focused }}
                    defaultValue={menuItems[0]}
                    inputProps={{
                        className: styles.input
                    }}
                    disableUnderline
                    IconComponent={() => (
                        <svg className={styles.icon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 8L12 16L4 8" stroke="#4A4646" strokeWidth="2"/>
                        </svg>
                    )}
                >
                    {menuItems.map((e, i) => <MenuItem
                        key={i}
                        className={styles.menuItem}
                        value={e.replace(/\s+/g, '')}
                        classes={{ selected: styles.menuSelected }}
                    >{e}
                    </MenuItem>
                    )}
                </Select>
            )}
        </div>
    )
}

export default memo(SelectInput)